import React from 'react'
import { Link } from 'react-router-dom'
import ROUTES from 'utils/ROUTES'
import logo from 'assets/logo.png'

const ConnectionLayoutWithImageHeader: React.FC = () => {
  return (
    <>
      <div className="header-containter-with-bg">
        <div className="header-containter-with-bg__children">
          <Link to={ROUTES.Home}>
            <img src={logo} alt="logo Suez" />
          </Link>
        </div>
      </div>
    </>
  )
}

export default ConnectionLayoutWithImageHeader
